import { render, staticRenderFns } from "./ModalAddFileBlocked.vue?vue&type=template&id=08716513&"
import script from "./ModalAddFileBlocked.vue?vue&type=script&lang=js&"
export * from "./ModalAddFileBlocked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports